import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { every as _every, get as _get } from 'lodash';
import { combineLatest, Observable, of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

import {
  BillAccountsSelectors,
  BillingNotificationsState
} from '@amfam/billing/billaccount/data-access';
import { PolicySelectors, PolicySummarySelectors } from '@amfam/policy/data-access';
import { GoPaperLessSelectors } from '@amfam/policy/go-paperless/data-access';
import { profileQuery } from '@amfam/profile/data-access';
import { fromRouterActions } from '@amfam/shared/utility/navigation';

import * as fromRoot from '../core/store';

@Injectable({
  providedIn: 'root'
})
export class PostEnrollmentGuard {
  constructor(private store: Store<fromRoot.RootState>) {}

  canActivate(): Observable<boolean> {
    return combineLatest(
      this.store.select(PolicySelectors.selectPoliciesLoading),
      this.store.select(PolicySummarySelectors.selectPolicySummaryLoading),
      this.store.select(BillAccountsSelectors.selectBillAccountsAnyLoading),
      this.store.select(GoPaperLessSelectors.selectGoPaperlessLoading),
      this.store.select(profileQuery.selectProfileLoading),
      this.store.select(PolicySelectors.selectPolicyRisks),
      this.store.select(BillAccountsSelectors.selectAllBillAccountsNotifications),
      this.store.select(fromRoot.billingEligibleToGoPaperless),
      this.store.select(fromRoot.isEligibleToGoPaperless),
      this.store.select(fromRoot.getPrograms),
      this.store.select(fromRoot.getProgramsLoading),
      (
        policiesLoading,
        policySummaryLoading,
        billAccountsLoading,
        goPaperLessLoading,
        profileLoading,
        policies,
        billAccounts: BillingNotificationsState[],
        isBillingEligibleForPaperLess,
        isPolicyEligibleForPaperLess,
        programs,
        programsLoading
      ) => ({
        loading:
          billAccountsLoading ||
          policiesLoading ||
          goPaperLessLoading ||
          policySummaryLoading ||
          profileLoading ||
          (billAccounts.length > 0
            ? _every(
                billAccounts,
                billAccount => _get(billAccount, 'prefsFinishedLoading', false) === false
              )
            : false) ||
          programsLoading,
        eligibleForPaperLess:
          (isBillingEligibleForPaperLess || isPolicyEligibleForPaperLess) &&
          !(_get(programs, 'length', 0) > 0)
      })
    ).pipe(
      filter(state => !state.loading),
      switchMap(state => {
        if (!state.eligibleForPaperLess) {
          this.store.dispatch(
            fromRouterActions.Go({
              path: ['/overview']
            })
          );
          return of(false);
        } else {
          return of(true);
        }
      })
    );
  }
}
